// Renderiza el markdown de los documentos legales (Términos, Privacidad,
// Prohibidos). No usamos una lib externa por peso — un parser ligero cubre
// el formato que realmente usamos: `## / ### títulos`, `**bold**`, listas
// con `-`, separadores `---`, y párrafos. Se lee bien en móvil y desktop.
//
// Uso: <LegalContent content={md} />

function inline(text, keyBase) {
  // Bold + escape < / > básico. El resto es texto crudo.
  const parts = [];
  const regex = /\*\*(.+?)\*\*/g;
  let lastIdx = 0;
  let m;
  let i = 0;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > lastIdx) {
      parts.push(text.slice(lastIdx, m.index));
    }
    parts.push(
      <strong key={`${keyBase}-b-${i++}`} className="text-white font-semibold">{m[1]}</strong>
    );
    lastIdx = m.index + m[0].length;
  }
  if (lastIdx < text.length) parts.push(text.slice(lastIdx));
  return parts;
}

export default function LegalContent({ content }) {
  if (!content) return null;
  const lines = content.replace(/\r\n/g, "\n").split("\n");
  const blocks = [];
  let list = null;
  const flushList = () => {
    if (list && list.length) {
      blocks.push(
        <ul key={`ul-${blocks.length}`} className="list-disc pl-6 space-y-1.5 text-neutral-300">
          {list.map((it, i) => (
            <li key={i}>{inline(it, `li-${blocks.length}-${i}`)}</li>
          ))}
        </ul>
      );
    }
    list = null;
  };

  let paraBuf = [];
  const flushPara = () => {
    if (paraBuf.length) {
      const joined = paraBuf.join(" ");
      blocks.push(
        <p key={`p-${blocks.length}`} className="text-neutral-300 leading-relaxed">
          {inline(joined, `p-${blocks.length}`)}
        </p>
      );
      paraBuf = [];
    }
  };

  for (const rawLine of lines) {
    const line = rawLine.trimEnd();
    if (!line.trim()) { flushList(); flushPara(); continue; }
    if (/^---+$/.test(line.trim())) {
      flushList(); flushPara();
      blocks.push(<hr key={`hr-${blocks.length}`} className="border-t border-[#262626] my-6" />);
      continue;
    }
    if (line.startsWith("# ")) {
      flushList(); flushPara();
      blocks.push(
        <h1 key={`h1-${blocks.length}`} className="font-display text-2xl sm:text-3xl mt-6 mb-3 text-white uppercase tracking-tight">
          {inline(line.slice(2), `h1-${blocks.length}`)}
        </h1>
      );
      continue;
    }
    if (line.startsWith("## ")) {
      flushList(); flushPara();
      blocks.push(
        <h2 key={`h2-${blocks.length}`} className="font-display text-lg sm:text-xl mt-8 mb-3 text-[#EF4444] uppercase tracking-tight">
          {inline(line.slice(3), `h2-${blocks.length}`)}
        </h2>
      );
      continue;
    }
    if (line.startsWith("### ")) {
      flushList(); flushPara();
      blocks.push(
        <h3 key={`h3-${blocks.length}`} className="font-display text-base sm:text-lg mt-5 mb-2 text-white">
          {inline(line.slice(4), `h3-${blocks.length}`)}
        </h3>
      );
      continue;
    }
    if (/^-\s+/.test(line)) {
      flushPara();
      if (!list) list = [];
      list.push(line.replace(/^-\s+/, ""));
      continue;
    }
    // Párrafo — acumulamos líneas contiguas para reflow natural.
    flushList();
    paraBuf.push(line);
  }
  flushList();
  flushPara();

  return (
    <div className="text-sm sm:text-base leading-relaxed">
      {blocks}
    </div>
  );
}
